import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { PracticeService } from 'src/app/services/practice.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss']
})
export class MemberComponent implements OnInit {
  public memberId;
  public member;
  public loading:boolean=true;
  public resetLink:string='';
  public recoverLink:string='';

  constructor(
    private _member: MemberService,
    private _notify: NotificationService,
    private _route: ActivatedRoute,
    private _practice: PracticeService
  ) {
    this.memberId=this._route.snapshot.paramMap.get('id');
    this.resetLink=environment.frontendUrl+'/account/verify-email/';
    this.recoverLink=environment.frontendUrl+'/recover/';
  }

  getMember(){
    this._member.getMember(this.memberId).subscribe(
      res=>{
        // console.log(res);
        this.member=res;
        this.loading=false;
      }
    );
  }

  public generateResetLink()
  {
    this._member.generateResetLink(this.memberId).subscribe(
      res=>{
        this.member.reset_token=res.token;
      }
    );
  }

  public updateMemberMentor(){
    this._member.setMemberMentor(this.member.id, this.member.mentor_id).subscribe(
      res=>{
        this.member=res;
        this._notify.showMessage('Mentor updated', 'OK');
      }
    );
  }

  public resendMemberInvitation(inviteId:number){
    this._practice.reinvitePracticeMember(inviteId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
      }
    );
  }

  public resendMemberVerification(memberId:number){
    this._member.resendUserVerificationEmail(memberId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
      }
    );
  }

  public deactivateSub(subId:number, userId:number)
  {
    if(confirm('Confirm de-activation of this user subscription by clicking "OK". This ONLY removes makes this subscription show as inactive on the on-demand system, please make sure you have already deactivated their subscription within Stripe first.'))
    {
      this._member.deactivateSub(subId, userId).subscribe(
        res=>{
          if(res.success)
          {
            this._notify.showMessage(res.success, 'OK');
            this.getMember();
          }
        }
      );
    }
    return false;
  }

  ngOnInit() {
    this.getMember();
  }

}
